import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PageState } from './types';

export const initialState: PageState = {
    title: 'Dashboard',
    description: '',
    breadcrumb: [],
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        updatePage(state, payload: PayloadAction<PageState>) {
            state.title = payload.payload.title;
        },
    },
});

export const { updatePage } = pageSlice.actions;

export default pageSlice.reducer;
